import { Form } from "formik";
import styled from "styled-components";
import { StyledField } from "../StyledField";

export const SError = styled.p`
	margin-top: 0.5rem;
	color: ${({ theme }) => theme.color.red};
	&:first-of-type {
		margin-top: 0;
	}
`;

export const SFormFooter = styled.footer`
	display: flex;
	gap: 1rem;
	margin-top: 1rem;
`;

export const SForm = styled(Form)`
	${StyledField} {
		margin-bottom: 0.8rem;
		input {
			margin-bottom: 0.2rem;
		}
		span {
			color: ${({ theme }) => theme.color.red};
		}
	}
`;
